/**
 * 비동기 함수를 try-catch 없이 안전하게 실행하게 도와주는 유틸리티
 * @param {Promise} promise
 * @returns {Promise<[any, Error|null]>}
 */
export const safe = async (promise) => {
	try {
		const data = await promise;
		return [data, null];
	} catch (err) {
		return [null, err];
	}
};